var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlutter = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 166 202",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: "85%",
  stopColor: "#616161",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "0%",
  x2: "0%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: "85%",
  stopColor: "#616161",
  stopOpacity: 0
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#42a5f5",
  fillOpacity: 0.8,
  d: "m38 129-28-28 90-91h56m0 84h-56l-21 21 28 28"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0d47a1",
  d: "m80 171 20 21h56l-49-49"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#42a5f5",
  d: "m52 143 28-28 27 28-27 28z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M60 163h39v5H60z",
  transform: "rotate(-45 80 143)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "m80 171 41-15-14-13"
})));
export default SvgFlutter;